// @tenorlab/nuxt-dashboard-pro
// file: app/utils/dashboard.utils.ts
import type { IDashboardConfig } from '@tenorlab/vue-dashboard'

export const sortDashboardConfigs = (configs: IDashboardConfig[]): IDashboardConfig[] => {
  return (configs || []).sort((a, b) => {
    const isADefault = a.dashboardId === 'default'
    const isBDefault = b.dashboardId === 'default'

    // 1. If 'a' is default and 'b' is not, 'a' comes first (-1)
    if (isADefault && !isBDefault) {
      return -1
    }

    // 2. If 'b' is default and 'a' is not, 'b' comes first (1)
    if (isBDefault && !isADefault) {
      return 1
    }

    // 3. If neither is default (or both are, which shouldn't happen),
    // sort alphabetically (A-Z) by dashboardId.
    return a.dashboardId.localeCompare(b.dashboardName)
  })
}

/* 
if (configs.length > 1) {
  const numericOnes = configs.filter(
    (x) => x.dashboardId !== 'default' && !isNaN(x.dashboardId as any),
  )
  if (numericOnes.length > 0) {
    result = Math.max(...numericOnes.map((x) => Number(x.dashboardId))) + 1
  }
  if (!result || isNaN(result)) {
    return 2
  }
  return result
}
*/
export const getNewDashboardId = (configs: IDashboardConfig[]): number => {
  let result = 2
  if (configs.length > 1) {
    result =
      Math.max(
        ...configs
          .filter((x) => x.dashboardId !== 'default' && !isNaN(x.dashboardId as any))
          .map((x) => Number(x.dashboardId)),
      ) + 1
  }
  if (isNaN(result) || `${result}`.indexOf('Infinity') > -1) {
    return 2
  }
  return result
}
